import { gatewayApi } from "./api";

// One way to report what happened on the pricing screens. It goes to our own database (POST /analytics/event); a provider can be
// plugged in later by changing this file alone. It never throws and never slows a page down.
const anonId = () => {
  try {
    let a = window.localStorage.getItem("hv.anon");
    if (!a) {
      a = (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) || String(Math.random()).slice(2);
      window.localStorage.setItem("hv.anon", a);
    }
    return a;
  } catch {
    return null;
  }
};

export function track(event, props = {}, token) {
  try {
    gatewayApi.post("/analytics/event", { event, props, anon_id: anonId() }, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined).catch(() => {});
  } catch {
    /* analytics must never break a page */
  }
}
